import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  cancelButtonVariant: 'tertiary',
  dialogOptions: { type: 'panel' },
  formLayout: 'pickup',
  storesLayout: 'bopis'
} satisfies RecursivePartial<DialogConfig['pickupInStore']>
